import React from 'react';
export function TermsContent() {
  return <div className="space-y-6" data-id="element-463">
      <section data-id="element-464">
        <h4 className="text-lg font-bold text-white mb-2" data-id="element-465">1. Introducción</h4>
        <p data-id="element-466">
          Bienvenido a Estrategias Digitales A-Z. Al contratar nuestros
          servicios de diseño y desarrollo web, usted acepta los siguientes
          términos y condiciones. Estos términos rigen la relación comercial
          entre el cliente y Estrategias Digitales A-Z, operando bajo las leyes
          de la República de Costa Rica.
        </p>
      </section>

      <section data-id="element-467">
        <h4 className="text-lg font-bold text-white mb-2" data-id="element-468">2. Servicios</h4>
        <p data-id="element-469">
          Nos especializamos en la creación de menús digitales, diseño web y
          estrategias digitales. El alcance específico de cada proyecto (tiempos
          de entrega, número de revisiones y entregables) se detalla en el plan
          seleccionado (Mis Primeros Pasos, Despegue Digital o Dominio Total) o
          en la propuesta personalizada acordada.
        </p>
      </section>

      <section data-id="element-470">
        <h4 className="text-lg font-bold text-white mb-2" data-id="element-471">
          3. Pagos y Tarifas
        </h4>
        <p data-id="element-472">
          Para iniciar cualquier proyecto, se requiere el pago acordado según el
          plan seleccionado. Aceptamos pagos mediante transferencia bancaria
          (SINPE Móvil/IBAN en Costa Rica), tarjeta de crédito/débito y PayPal.
        </p>
        <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-473">
          <li data-id="element-474">Los precios están expresados en Dólares Americanos (USD).</li>
          <li data-id="element-475">
            No se realizarán reembolsos una vez iniciado el trabajo de diseño,
            salvo incumplimiento comprobable por parte de nuestra agencia.
          </li>
        </ul>
      </section>

      <section data-id="element-476">
        <h4 className="text-lg font-bold text-white mb-2" data-id="element-477">
          4. Propiedad Intelectual
        </h4>
        <p data-id="element-478">
          Una vez finalizado el proyecto y cubierto el pago total, el cliente
          obtiene los derechos de uso sobre el diseño final y los contenidos
          entregados. Estrategias Digitales A-Z se reserva el derecho de mostrar
          el trabajo realizado en su portafolio y materiales promocionales, a
          menos que se acuerde un acuerdo de confidencialidad (NDA) por escrito.
        </p>
      </section>

      <section data-id="element-479">
        <h4 className="text-lg font-bold text-white mb-2" data-id="element-480">
          5. Revisiones y Cambios
        </h4>
        <p data-id="element-481">
          Cada plan incluye un número específico de rondas de revisión. Cambios
          adicionales fuera del alcance original o que excedan las rondas
          estipuladas se facturarán por separado a nuestra tarifa por hora
          vigente.
        </p>
      </section>

      <section data-id="element-482">
        <h4 className="text-lg font-bold text-white mb-2" data-id="element-483">
          6. Limitación de Responsabilidad
        </h4>
        <p data-id="element-484">
          Estrategias Digitales A-Z no se hace responsable por pérdidas
          indirectas, lucro cesante o daños derivados del uso del sitio web
          entregado. El cliente es responsable de asegurar que el contenido
          proporcionado para su sitio (textos, imágenes, logos) no infrinja
          derechos de terceros.
        </p>
      </section>

      <section data-id="element-485">
        <h4 className="text-lg font-bold text-white mb-2" data-id="element-486">7. Jurisdicción</h4>
        <p data-id="element-487">
          Cualquier disputa relacionada con estos términos se regirá por las
          leyes de Costa Rica y se intentará resolver primero mediante
          conciliación amistosa antes de proceder a instancias legales en San
          José, Costa Rica.
        </p>
      </section>

      <div className="pt-4 text-sm text-gray-500 border-t border-white/10" data-id="element-488">
        Última actualización: Febrero 2026
      </div>
    </div>;
}